import React from 'react';
import { DescriptionFieldProps } from "@rjsf/utils";
import { isRootId } from './ids';

const DescriptionFieldTemplate = (props: DescriptionFieldProps) => {
    const { description, id } = props;

    if (id === 'undefined__description' || !description) {
        return null;
    }

    /* The root description is the service's own blurb from its schema — the
       same paragraph on every item of that service, and often several hundred
       words of it. The reader came here to edit one item, already knows which
       service they are in from the nav, and the catalogue is where the service
       is described.

       Only the root: a nested object's description says what that particular
       group of fields is for, which is worth reading and is not repeated
       anywhere else. */
    if (isRootId(id)) {
        return null;
    }

    return (
        <div id={id} className="sb-field__desc sb-field__desc--section">
            {description}
        </div>
    );
};

export default DescriptionFieldTemplate;
